import { DefaultTheme } from 'styled-components';

export default {
  title: 'chemistry',

  colors: {
    background: '#EFF1F7',
    background_hover: '#EDF7F3',
    black: '#000000',
    primary: '#339792',
    secondary: '#E15D7E',
    grey: '#DDDDDD',
    dark_grey: '#929292',
    white: '#FFFFFF',
    white_variant: '#FAFAFA',
  },
} as DefaultTheme;
